import { Filter } from '../helpers/Filter';
import { Module } from '../Module';
import { GetUsersForDataAlertRequest, IGetUsersForDataAlertResult } from '../ServerApi/requests/GetUsersForDataAlertRequest';
import { IUser } from '../ServerApi/types/IUser';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';
import { ResourceQuery } from './ResourceQuery';

export class DataAlertUsers extends Resource<IUser> {

  public static $inject = ['FetcherFactory'];

  constructor(FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetUsersForDataAlertRequest,
      (result: IGetUsersForDataAlertResult) => result.users));
  }

  public getUsersQuery(dataAlertId: string, filter: string): ResourceQuery<IUser> {
    return this.all()
      .withExtraParams({ 'dataAlertId': dataAlertId })
      .withFilters([Filter.stringFieldMatches('displayName', filter)]);
  }

}

Module.instance().service('DataAlertUsers', DataAlertUsers);
